import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Typography, SvgComponent } from '@quikr/ui';
import HamburgerSprite from '@quikr/ui/src/assets/hamburger-sprite.svg';
import DownArrowKeyboard from '@quikr/ui/src/icons/KeyboardDownArrow';
import { CATEGORY_ICON_MAPPING } from '../../../helpers/postad';

const Li = styled.li`
  border-bottom: 1px solid ${({ theme }) => theme.colors.Neutral[200]};
  border-right: 1px solid ${({ theme }) => theme.colors.Neutral[200]};
  p {
    color: ${({ theme }) => theme.colors.TextAlpha};
  }
  ${({ isMobile, isActive }) =>
    !isMobile &&
    isActive &&
    css`
      border-right: none;
      p {
        color: ${({ theme }) => theme.colors.Primary};
      }
      .linkIcon {
        fill: ${({ theme }) => theme.colors.Primary};
      }
    `}
  figure {
    margin-right: 10px;
    svg {
      width: 25px;
      height: 25px;
    }
  }
  @media (max-width: 767px) {
    border-right: none;
  }
`;

const Qlink = styled.a`
  ${({ type }) => {
    switch (type) {
      case 'Icon':
        return css`
          height: 28px;
          width: 28px;
        `;
      case 'links':
        return css`
          color: ${({ theme }) => theme.colors.Primary};
          text-decoration: none;
          padding: 15px 20px;
          &:before {
            content: '';
            position: absolute;
            z-index: -1;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            transform: scaleX(0);
            transform-origin: 0 50%;
            transition-property: transform;
            transition-duration: 0.3s;
            transition-timing-function: ease-out;
            border-left: 5px solid ${({ theme }) => theme.colors.Primary};
          }
          &:before {
            ${({ isMobile, isActive }) =>
              !isMobile &&
              isActive &&
              css`
                transform: scaleX(1);
              `}
          }
          @media screen and (min-width: 768px) {
            padding: 12px 20px;
          }
        `;
    }
  }}
`;

const Label = styled.div`
  p {
    line-height: normal;
    min-width: 60px;
  }
  span {
    color: ${({ theme }) => theme.colors.Neutral[500]};
    line-height: 16px;
  }
  @media screen and (min-width: 768px) {
    span {
      margin-top: 5px;
    }
  }
`;

const ArrowIcone = styled(DownArrowKeyboard)`
  fill: #000;
  width: 20px;
  transform: rotate(-90deg);
`;

const CategoryList = (props) => {
  const { categories, isMobile, setActiveIndex, activeIndex, handleOnClick } = props;

  const handleClick = (index) => {
    setActiveIndex(index);
    handleOnClick(true);
  };

  return (
    <ul>
      {categories.map(({ category }, index) => (
        <Li
          className="pR cP"
          key={`${category.name}+${index}`}
          onMouseEnter={() => setActiveIndex(index)}
          isMobile={isMobile}
          onClick={() => isMobile && handleClick(index)}
          isActive={index === activeIndex}
        >
          <Qlink
            href={category.href}
            isMobile={isMobile}
            type="links"
            className="dF jcC"
            isActive={index === activeIndex}
          >
            <figure className="dF jcC">
              <SvgComponent
                svgSprite={HamburgerSprite}
                id={`ic_${CATEGORY_ICON_MAPPING[category.id]}`}
              />
            </figure>
            <Label className="dFA jcSB f1">
              <Typography tagName="p" modifiers={['medium', 'bt1']} className="dF taC">
                {category.name}
              </Typography>
              <ArrowIcone className="linkIcon" />
            </Label>
          </Qlink>
        </Li>
      ))}
    </ul>
  );
};

CategoryList.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      category: PropTypes.object,
      subdata: PropTypes.array,
      subtype: PropTypes.bool,
      subcat: PropTypes.array
    })
  ),
  isMobile: PropTypes.bool,
  setActiveIndex: PropTypes.func,
  activeIndex: PropTypes.number,
  changeView: PropTypes.func
};

CategoryList.defaultProps = {
  categories: {}
};

export default CategoryList;
